import { useCallback, useRef } from 'react';

export function useFreezeHeight() {
    const ref = useRef<HTMLDivElement>(null);

    const setFreeze = useCallback(() => {
        const height = ref.current?.clientHeight;

        if (height) {
            ref.current?.style.setProperty('height', `${height}px`);
        }
    }, []);

    const setUnfreeze = useCallback(() => {
        ref.current?.style.removeProperty('height');
    }, []);

    return {
        ref,
        setFreeze,
        setUnfreeze,
    };
}
